var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{name: 'home'}}},[_c('img',{staticClass:"logoimg",attrs:{"src":require("./DataExpo.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }